import React, {useEffect, useState, useContext} from 'react';
import './AdminManagement.css';
import { IconButton } from '@mui/material';
import { EditIcon, TrashIcon, AddIcon, CachedIcon } from '../../../assets/icons/icons.tsx';
import axios from 'axios';
import config from '../../../config.js';
import { AuthContext } from '../../../contexts/authContext';
import UserManagementDialog from './UserManagementDialog.js';
import DeleteUserDialog from './DeleteUserDialog.js';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import useNotification from '../../../hooks/useNotification';

const ActionCell = (params, openDialog, openDeleteDialog) => {
	return(
		<div>
			<IconButton onClick={() => openDialog('mod')} size='small' >
				<EditIcon addClass='pointer'></EditIcon>
			</IconButton>
			<IconButton onClick={openDeleteDialog} size='small'>
				<TrashIcon addClass="pointer" ></TrashIcon>
			</IconButton>
		</div>
	)
}

const ActionHeaderCell = (params, openDialog, getUsers) => {
	return(
		<div className="centered-cell" >
			<IconButton title='Ricarica dati' onClick={() => getUsers()} size='small' >
				<CachedIcon addClass='pointer'/>
			</IconButton>
			<IconButton onClick={() => openDialog('ins')} size='small' >
				<AddIcon addClass='pointer'/>
			</IconButton>
		</div>
	)
}

const CustomCell = (params) => {
	return(
		<div className="centered-cell">
			{params.field === 'role' ? 
				params.value === 'A' ? 'Admin' : params.value === 'E' ? 'Editor' : params.value === 'M' ? 'Monitoring' : 'Municipalità'
			:
				params.value
			}
		</div>
	)
}

const LogsDateCell = (params) => {
    const formatDataInsToShow = (data) => {
        if(!data)return "";
        let dateToRender = new Date(data);
        return dateToRender.toLocaleString("it-IT")
    }

    return(
        <div>
            {formatDataInsToShow(params.value)}
        </div>
    )
}

function AdminManagement(props) {

	const auth = useContext(AuthContext);
	const { notificationError } = useNotification();
	const [usersLoading, setUsersLoading] = useState(false);
    const [rows, setRows] = useState([])
	const [lastCellData, setLastCellData] = useState(null);
	
	const [openUserManagementDialog, setOpenUserManagementDialog] = useState(false);
	const [openDeleteUserDialog, setOpenDeleteUserDialog] = useState(false);

	const columns = [
		{ field: 'ACTION', headerClassName: 'header-cell action-cell', headerName: "", type: 'text', align:'center', headerAlign: 'center', disableColumnMenu: true, sortable: false, width: 75, editable: false, renderCell: (params) => ActionCell(params, handleOpenUserManagementDialog, handleOpenDeleteUserDialog), renderHeader: (params) => ActionHeaderCell(params, handleOpenUserManagementDialog, getUsers)},
		{ field: 'nome', headerClassName: 'header-cell nome', headerName: "Nome", type: 'text', width: 150, editable: false},
		{ field: 'cognome', headerClassName: 'header-cell cognome', headerName: "Cognome", type: 'text', width: 150, editable: false},
		{ field: 'email', headerClassName: 'header-cell email', headerName: "Email", type: 'text', width: 250, editable: false},
		//{ field: 'admin', headerClassName: 'header-cell flag-admin', headerName: "Admin", type: 'text', width: 75, editable: false, align: 'center', headerAlign: 'center',  renderCell: (params) => CustomCell(params)},
		{ field: 'role', headerClassName: 'header-cell role', headerName: "Ruolo", type: 'text', width: 100, editable: false, align: 'left', headerAlign: 'left',  renderCell: (params) => CustomCell(params)},
		{ field: 'city', headerClassName: 'header-cell city', headerName: "Città", type: 'text', width: 120, editable: false, align: 'left', headerAlign: 'left'},
		{ field: 'ultimaModifica', headerClassName: 'header-cell data-ultima-modifica', headerName: "Data Ultima Modifica", type: 'text', width: 300, editable: false, renderCell: (params) => LogsDateCell(params)},
		{ field: 'inserimento', headerClassName: 'header-cell data-inserimento', headerName: "Data Inserimento", type: 'text', width: 300, editable: false, renderCell: (params) => LogsDateCell(params)},
		{ field: 'sub', headerClassName: 'header-cell sub', headerName: "Sub", type: 'text', width: 200, editable: false}
		/* { field: 'flagAttivo', headerClassName: 'header-cell flag-attivo', headerName: "Attivo", type: 'text', width: 75, align:'center', headerAlign: 'center', editable: false,  renderCell: (params) => CustomCell(params)}, */
	];

	useEffect(() => {
		getUsers();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const getUsers = async() => {
		try {
			setUsersLoading(true);

			const params = {};

			const axiosParams = {
				url: '/get-users',
				method: 'get',
				baseURL: config.API_URL,
				headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
				params
			};

			const response = await axios(axiosParams);

			setRows(response.data)
			setUsersLoading(false);
		} catch (error) {
			if (error?.status === 401 || error?.status === 403) {
				props.logOut();
			} else {
				if (typeof error.response.data.errorMessage === 'string') {
					notificationError(error.response.data.errorMessage);
				} else {
					notificationError('Oops, an error has occured');
				}
			}
			setUsersLoading(false);
		}
	}

	const handleOpenUserManagementDialog = (mode) => {
		setOpenUserManagementDialog(mode);
	}

	const handleCloseUserManagementDialog = () => {
		setOpenUserManagementDialog(false);
		setLastCellData(null);
	}

	const handleOpenDeleteUserDialog = () => {
		setOpenDeleteUserDialog(true)
	}
	
	const handleCloseDeleteUserDialog = () => {
		setOpenDeleteUserDialog(false);
		setLastCellData(null);
	}

    return (
        <div className='component-container home'>
			<div className='component-card'>
                <DataGridPremium
					rows={rows}
					columns={columns}
					className="users-table"
					loading={usersLoading}
					rowHeight={30}
					onCellClick={(params) => setLastCellData(params.row)}
					initialState={{ pinnedColumns: { left: ['ACTION'], right: [] } }}
					getCellClassName={(params) => {
						if(params.field==="ACTION"){
							return 'centered-cell';
						}
					}}
					getRowId={(row) => row.email}
					disableAggregation
					disableRowGrouping
					disableDensitySelector
				/>
            </div>
			<UserManagementDialog {...{
				openUserManagementDialog,
				handleCloseUserManagementDialog,
				lastCellData,
				getUsers
			}}/>

			<DeleteUserDialog {...{
				openDeleteUserDialog,
				handleCloseDeleteUserDialog,
				lastCellData,
				getUsers
			}}/>
        </div>
    )
}

export default AdminManagement